export const prettifyPercentage = (percent: number) => {
  if (percent % 1 === 0) {
    return `${percent}%`;
  }
  return `${percent.toFixed(1)}%`;
};
